// utils/main.ts
let cachedUserInfo: any = null;

 

export function getUserInfoFromToken() { 
  if (cachedUserInfo) return cachedUserInfo;

  const token = localStorage.getItem("accessToken");
  if (!token || !token.includes(".")) return null;

  try {
    const payload = token.split(".")[1];

    // Convert base64url to base64
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');

    const decodedPayload = JSON.parse(atob(padded));
    
    cachedUserInfo = {
      id: decodedPayload.id,
      role: decodedPayload.role,
      username: decodedPayload.username,
      workspaceId: decodedPayload.workspaceId,
      workspaceName: decodedPayload.workspaceName,
      profile: decodedPayload.profile,
    };
    
    return cachedUserInfo;
  } catch (error) {
    console.error("Failed to decode token", error);
    localStorage.removeItem("accessToken"); // Optional: clear bad token
    return null;
  }
}
